<script>
export default {
    inject: {
        $parentId: { default: '' },
        $searchContext: { default: null },
    },
}
</script>
